import { render } from "./ThePanelTopBar.vue?vue&type=template&id=17c02a60"
import script from "./ThePanelTopBar.vue?vue&type=script&lang=js"
export * from "./ThePanelTopBar.vue?vue&type=script&lang=js"
script.render = render

export default script